import React from 'react';
import { BannerArticles } from './view/bannerArticles';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'BannerArticles', 
  itemElt: (item, cmsOption) => <BannerArticles item={item} cmsOption={cmsOption} />
}